import { studySession } from "./study-session"

export const challenges = {
  studySession,
}
